export const TERMS_TEXT = `I am aware and agree with the terms
and conditions of this Agreement and the Privacy Policy of the Seller, I give permission for the website
administration to collect, process and use my personal data on the lawful basis. I confirm that all data
indicated by me belong to me personally. I am familiar with the rights that arise in connection with the
processing of my personal data, as well as with the purposes of processing and application of my personal
data.`;
